import GeneralTP from './general';

export default {
  GeneralTP,
};
